import { getConfig } from '../../config';
import { clearTokens } from '../../services/auth/auth';
import { createFreshTokensGetter } from '../../services/auth/fresh-tokens';
import { queryClient } from '../../services/datastore';
import { Api } from '../../services/network';

/**
 * Le rafraîchissement de token venait d'une copie locale, identique à celles de
 * `driverApi` et `boApi` — la même logique écrite trois fois, dont seule
 * l'instance qui poste le rafraîchissement différait.
 *
 * `createFreshTokensGetter` corrige au passage un défaut que cette copie portait :
 * elle lisait les tokens avec `getQueryData`, qui ne voit que le cache mémoire.
 * Une requête émise avant que `useTokens` ait résolu partait donc **sans bearer**,
 * silencieusement. La fabrique utilise `ensureQueryData`, qui relit le stockage
 * quand le cache est froid.
 *
 * Le thunk n'est pas décoratif : il évite le cycle avec `getPassengerApi`, qui reçoit
 * cette fonction en argument.
 */
export const getFreshTokens = createFreshTokensGetter(() => getPassengerApi());

let _passengerApi: Api | null;

export const getPassengerApi = (): Api => {
  const passengerApiUrl = getConfig().passengerApiUrl;

  if (!passengerApiUrl) {
    console.error('passengerApiUrl must be defined');
    throw new Error('passengerApiUrl must be defined');
  }

  if (!_passengerApi) {
    _passengerApi = new Api(passengerApiUrl, getFreshTokens, () => {
      clearTokens(queryClient);
    });
  }
  return _passengerApi;
};
